/**
 * 用户配置弹窗状态管理
 * 方便在全站任意位置控制用户配置弹窗的显示与隐藏
 */
import { create } from 'zustand';

interface UserProfileState {
  open: boolean;
  currentTab: 'account' | 'profile' | 'settings';
  showDialog: (tab: 'account' | 'profile' | 'settings') => void;
  closeDialog: (reset?: boolean) => void;
  setCurrentTab: (currentTab: 'account' | 'profile' | 'settings') => void;
  reset: () => void;
}

// 创建 store
const useUserProfileStore = create<UserProfileState>(set => ({
  currentTab: 'account',
  open: false,
  showDialog: (tab: 'account' | 'profile' | 'settings' = 'account') => set({ open: true, currentTab: tab }),
  closeDialog: (reset = false) => {
    set({ open: false });
    if (reset) {
      set({ currentTab: 'account' });
    }
  },
  setCurrentTab: (currentTab: 'account' | 'profile' | 'settings') => set({ currentTab }),
  reset: () =>
    set({
      open: false,
      currentTab: 'account',
    }),
}));

export default useUserProfileStore;
